import { http } from '@/http/axios.js'

// 管理员列表
export function getListAPI(params) {
  return http({
    url: `/api/admin/rbac/adminUser/page`,
    method: 'get',
    params
  })
}


export function getTreeAPI() {
  return http({
    url: `/api/admin/rbac/adminUser/tree`,
    method: 'get',
  })
}

// 新增管理员
export function addAPI(data) {
  return http({
    url: `/api/admin/rbac/adminUser/add`,
    method: 'post',
    data
  })
}
// 编辑管理员
export function editAPI(data) {
  return http({
    url: `/api/admin/rbac/adminUser/edit`,
    method: 'post',
    data
  })
}
// 删除管理员
export function delAPI(id) {
  return http({
    url: `/api/admin/rbac/adminUser/del`,
    method: 'post',
    data: { id }
  })
}

// 管理员详情
export function getDetailAPI(id) {
  return http({
    url: `/api/admin/rbac/adminUser/detail`,
    method: 'get',
    params: { id }
  })
}
// 角色列表
export function getRoleList(params) {
  return http({
    url: '/admin/role/page',
    method: 'GET',
    params
  })
}
